import TileKit from '@/legacy/TileKit';
import BottomFrameRule from './BottomFrame/BottomFrameRule';
import GetItBy from './BottomFrame/GetItBy';
import Shipping from './BottomFrame/Shipping';
import { useDeliveryOrPickupChipGetItBy } from './hooks';

const BottomFrame = () => {
  const { getItBy } = useDeliveryOrPickupChipGetItBy();

  return (
    <TileKit.Frame className="bottom-frame">
      <BottomFrameRule getItBy={getItBy} />
      <TileKit.Pane fullWidth>
        <div className="flex left-[-1px] my-4 top-[-1px]">
          <Shipping getItBy={getItBy} />
          <GetItBy getItBy={getItBy} />
        </div>
      </TileKit.Pane>
    </TileKit.Frame>
  );
};

export default BottomFrame;
